export default "__VITE_ASSET__d3a1794b__"